import React from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import UDFormInput from 'ud-form/components/input';
import Modal from 'ud-ui/components/modal';
import { UDButton } from 'ud-ui/components';
import { DeviceDto } from 'modules/core/supabase/tables/device';

export interface DeviceFormValues {
  name: string;
}

const validationSchema = yup.object().shape({
  name: yup.string().min(1, 'Обязательное поле').required('Обязательное поле'),
});

interface DeviceFormProps {
  initValue?: DeviceDto;
  onSubmit: (values: DeviceFormValues) => Promise<void>;
}

const DeviceForm = React.memo(function DeviceForm(props: DeviceFormProps) {
  const { initValue, onSubmit } = props;

  const initialValues: DeviceFormValues = {
    name: initValue?.name ?? '',
  };

  const isEdit = Boolean(initValue);

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
      {(formProps) => (
        <Form className="w-[454px]">
          <Modal.Body className="flex-column gap-4 overflow-hidden">
            <UDFormInput name="name" placeholder="Название" errorVisible />
          </Modal.Body>
          <Modal.Footer>
            <UDButton
              variant="primary"
              type="submit"
              loading={formProps.isSubmitting}
              stretch
              disabled={!formProps.dirty}
            >
              {isEdit ? 'Сохранить' : 'Создать'}
            </UDButton>
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  );
});

export default DeviceForm;
